exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.big.el-select[data-v-43a47f75] {\n  width: 450px;\n}\n.biggest.el-textarea[data-v-43a47f75] {\n  width: 700px;\n}\n.el-checkbox__label[data-v-43a47f75] {\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43a47f75","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/AcademicDirectorJudgement.vue
// module id = RWBw
// module chunks = 1